module.exports = __webpack_public_path__ + "img/1728543494311-Screenshot_10-10-2024_145756_www.instagram.com.jpeg.011d544c.webp";